/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';
import { getLocalizedStrings } from '../misc';

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            FORGOT_PASSWORD_SCHEMA_MESSAGES: { INVALID_EMAIL }
          }
        }
      } = getLocalizedStrings();
      return INVALID_EMAIL;
    })
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            FORGOT_PASSWORD_SCHEMA_MESSAGES: { USERNAME_REQUIRED }
          }
        }
      } = getLocalizedStrings();
      return USERNAME_REQUIRED;
    }),
  lastName: Yup.string().required(() => {
    const {
      USERS: {
        USER_AUTHENTICATION: {
          FORGOT_PASSWORD_SCHEMA_MESSAGES: { LAST_LAST_REQUIRED }
        }
      }
    } = getLocalizedStrings();
    return LAST_LAST_REQUIRED;
  })
});
